import firebase from "firebase";
import firestore from "firebase/firestore";

let firebaseConfig = {
  apiKey: "AIzaSyB6UvUSBPZo_G3UiSk1JP19h7v3-7lrGTI",
  authDomain: "canvas-development-56594.firebaseapp.com",
  databaseURL: "https://canvas-development-56594.firebaseio.com",
  projectId: "canvas-development-56594",
  storageBucket: "canvas-development-56594.appspot.com",
  messagingSenderId: "425631264253",
  appId: "1:425631264253:web:f39245c2881c076e"
};
// Initialize Firebase
const firebaseAPP = firebase.initializeApp(firebaseConfig);

export default firebaseAPP;
